//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head() {
    return {
      title: 'Galeri',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Galeri Charm berfungsi untuk mengakomodasi semua dokumentasi aktivitas Charm. Yuk Charm Girls! Temukan foto dan video seru tentang kegiatan baru Charm di sini.',
        },
      ],
    }
  },
}
